module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_02-538e2a69b199a7e66540b914dd82c0e0.png";